import {Injectable} from '@angular/core';
import {Message, PdsMessageLocation, PdsMessageType} from '../models/message';
import { OrderedMap } from '../models/ordered-map';
import {UntokenizedMessage} from '../models/untokenized-message';
import {MessageHistory} from '../message-history';
import {Subject} from 'rxjs';

export class MessageService {
  notificationMessages: OrderedMap<Message> = new OrderedMap<Message>();
  dockedMessages: OrderedMap<Message> = new OrderedMap<Message>();
  inlineMessages: OrderedMap<Message> = new OrderedMap<Message>();

  messageChangeStream: Subject<Message | Array<Message>> = new Subject<Message | Array<Message>>();

  getMessageMap(location: PdsMessageLocation): OrderedMap<Message> | undefined {
    switch (location) {
      default: //shut up typescript
      case 'FLOATING':
        return this.notificationMessages;
      case 'DOCKED':
        return this.dockedMessages;
      case 'INLINE':
        return this.inlineMessages;
    }
  }

  displayMessage(type: PdsMessageType, location: PdsMessageLocation, message: string | UntokenizedMessage, timeout?: number, channel?: string): void {
    let notificationMessage: Message = new Message(type, location, message, timeout, channel);
    let map = this.getMessageMap(notificationMessage.location);
    if (map == null) {
      return;
    }
    let old = map.get(notificationMessage.message);
    if (old != null && old.timeoutOccurred === false) {
      clearTimeout(old.timeoutObj);
      old.timeoutOccurred = true;
    }
    map.put(notificationMessage.message, notificationMessage);
    MessageHistory.add(notificationMessage);

    this.messageChangeStream.next(notificationMessage);
    //Timeout of zero will be no timeout.
    if (notificationMessage.timeout !== 0) {
      notificationMessage.timeoutObj = setTimeout(() => {
        //If map is null, we would never have called this function.
        map!.remove(notificationMessage.message);
        notificationMessage.timeoutOccurred = true;
        this.messageChangeStream.next(notificationMessage);
      }, notificationMessage.timeout);
    }
  }

  removeMessage(location: PdsMessageLocation, message: string): boolean {
    if (message != null) {
      let messageMap: OrderedMap<Message> | undefined = this.getMessageMap(location);
      if (messageMap != null) {
        let messageObj: Message | undefined = messageMap.remove(message);
        this.messageChangeStream.next(messageObj);
        if (messageObj != null) {
          clearTimeout(messageObj.timeoutObj);
          return true;
        }
      }
    }
    return false;
  }

  removeMessagesByLocation(...locations: Array<PdsMessageLocation>): void {
    locations.forEach((location: PdsMessageLocation) => {

      let messageMap: OrderedMap<Message> | undefined = this.getMessageMap(location);
      if (messageMap != null) {
        let messageUpdateArray: Array<Message> = [];
        messageMap.forEach((value: Message, key: string, index: number) => {
          messageUpdateArray.push(value);
        });
        messageMap.clear();
        this.messageChangeStream.next(messageUpdateArray);
      }
    });
  }
}
